import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';

export function getCurrentDate(): Date {
    return new Date(Date.now());
}

export function getCurrentDateAsISOString(): string {
    return new Date(Date.now()).toISOString();
}

export function parseDate(dateTime: string): Date {
    return new Date(dateTime);
}

export function getDate(dateTime: string): number {
    return new Date(dateTime).getDate();
}

export function getTime(dateTime: string): number {
    return new Date(dateTime).getTime();
}

export function isDateInPast(dateTime: string): boolean {
    return new Date(dateTime) < new Date(Date.now());
}

export function getStartOfDay(dateTime?: string): string {
    const date = dateTime ? parseDate(dateTime) : getCurrentDate();
    return startOfDay(date).toISOString();
}

export function getEndOfDay(dateTime?: string): string {
    const date = dateTime ? parseDate(dateTime) : getCurrentDate();
    return endOfDay(date).toISOString();
}

export function getStartOfMonth(dateTime?: string): string {
    const date = dateTime ? parseDate(dateTime) : getCurrentDate();
    return startOfMonth(date).toISOString();
}

export function getEndOfMonth(dateTime?: string): string {
    const date = dateTime ? parseDate(dateTime) : getCurrentDate();
    return endOfMonth(date).toISOString();
}
